module.exports = __webpack_public_path__ + "static/media/YF86_07.10d6c403.jpg";